import { useIntl } from 'react-intl';

import { IWaitTime } from 'generated/rbi-graphql';
import { getEstimatedTimeMessage } from 'pages/queue/utils';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

interface IWaitTimeWarningOptions {
  atStoreLocator: boolean;
  atCartConfirmation: boolean;
  atStoreConfirmation: boolean;
}

export const useQueueInformationFormatter = (waitTime?: IWaitTime | null) => {
  const { formatNumber, formatList } = useIntl();

  const formatHour = (hour: number) =>
    formatNumber(hour, { style: 'unit', unit: 'hour', unitDisplay: 'long' });
  const formatMinute = (minute: number) =>
    formatNumber(minute, { style: 'unit', unit: 'minute', unitDisplay: 'long' });
  const formatHourAndMinutesSkipZero = (hour: number, minute: number) =>
    formatList([hour && formatHour(hour), minute && formatMinute(minute)].filter(Boolean));

  const waitTimeWarningOptions = useFlag<IWaitTimeWarningOptions>(
    LaunchDarklyFlag.WAIT_TIME_WARNING_OPTIONS
  );

  const estimatedTime = getEstimatedTimeMessage({
    firingTimestamp: waitTime && new Date(waitTime.firingTimestamp ?? ''),
    dateNow: new Date(),
    formatHourAndMinutesSkipZero,
  });

  return {
    estimatedTime,
    waitTimeWarningOptions,
  };
};
